import Figure from "../generic/Figure"
import { Text } from "@chakra-ui/react"
import { FigureProps } from "@hydrologiq/shared/figures/generic/Figure"
import { DateTime } from "timezonecomplete"
import { dateDiffInDays, nowDateTime } from "@hydrologiq/common/helpers/date"
import FigureContent from "./FigureContent"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"
export type ServicePeriod = "Next" | "Previous"
export interface ServiceProps extends FigureProps {
  date?: DateTime
  period?: ServicePeriod
  shoDays?: boolean
}

const Service = ({ date, period = "Next", shoDays = false, ...rest }: ServiceProps) => {
  const now = nowDateTime()
  const diff = date ? dateDiffInDays(now, date) : undefined
  const daysLabel = shoDays && diff && diff > 0 ? <FigureContent.Label>in {diff} days</FigureContent.Label> : undefined
  return (
    <Figure {...rest} compact={isCompactFigure("summary")}>
      <FigureContent.Root>
        <FigureContent.SubText link={daysLabel}>scheduled</FigureContent.SubText>
        <FigureContent.Value>
          {date ? <Text>{date.format("dd-MM-YYYY")}</Text> : <Text>Not scheduled</Text>}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default Service
